import {AuwSearchBox} from "./AuwSearchBox";

if($('.searchbox').length) {
    $.each($('.searchbox'),function(i,e) {
        new AuwSearchBox($(e));
    });
}

